<template>
    <AdminNextIframe
        path="/pricing"
        :query="{ clientId: $route.params.id }" />
</template>

<script>
import AdminNextIframe from '@/components/ui/iframe/AdminNextIframe';

export default {
    name: 'ClientPricingManager',
    components: { AdminNextIframe }
}
</script>
